import { getIntegrationNameFromUrl } from "app/pages/sales-intelligence/common-components/export-table/getIntegrationNameFromUrl";
import type { ComponentType } from "react";
import type React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import type { ThunkDispatchCommon } from "single-spa/store/types";
import { setDynamicsEditableField } from "../../store/actions/export/dynamics";
import { setHsEditableField } from "../../store/actions/export/hubspot";
import { setSfEditableField } from "../../store/actions/export/salesforce";

const mapDispatchToProps = (dispatch: ThunkDispatchCommon) => {
    return bindActionCreators(
        {
            setSfEditableField,
            setHsEditableField,
            setDynamicsEditableField,
        },
        dispatch,
    );
};

type WithResetManagementExportProps = ReturnType<typeof mapDispatchToProps>;

const withResetManagementExport = <PROPS extends {}>(Component: React.ComponentType<PROPS>) => {
    const WrappedWithResetManagementExport = (props: PROPS & WithResetManagementExportProps) => {
        const { setSfEditableField, setHsEditableField, setDynamicsEditableField } = props;
        const { integrationName } = getIntegrationNameFromUrl();

        if (integrationName === "salesforce") {
            setSfEditableField(undefined);
        } else if (integrationName === "dynamics") {
            setDynamicsEditableField(undefined);
        } else {
            setHsEditableField(undefined);
        }

        return <Component {...(props as PROPS)} />;
    }

    return connect(
        null,
        mapDispatchToProps,
    )(WrappedWithResetManagementExport as ComponentType<any>) as unknown as React.ComponentType<PROPS>;
};

export default withResetManagementExport;
